import { SwishLogo } from '@/components/swish-logo';
import config from '@/config';
import { usePlaceCurrentOrderMutation } from '@/hooks/mutations/use-place-current-order-mutation';
import useCartStore from '@/stores/cart.store';
import { formatMoney } from '@/utils/Utils';

const SUBMIT_BUTTON_TEXT = 'Betala med swish';

export default function SubmitButton() {
  const { mutate, isPending } = usePlaceCurrentOrderMutation();
  const total = useCartStore((state) => state.totalPrice);

  return (
    <div>
      {/* Fees, discount and total */}
      <ul>
        <li className="flex items-center justify-between py-3 border-b border-gray-200 dark:border-gray-700/60">
          <div className="text-sm">Totalt</div>
          <div className="text-sm font-medium text-green-600 ml-2">{formatMoney(total)}</div>
        </li>
      </ul>

      {/* Submit button */}
      <button
        type="button"
        onClick={() => {
          mutate();
        }}
        disabled={isPending}
        className="btn w-full bg-violet-500 text-gray-100 hover:bg-violet-700 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white mb-4 py-2.5"
      >
        {isPending ? (
          'Påbörjar betalning...'
        ) : (
          <div className="flex items-center gap-2">
            <SwishLogo /> {SUBMIT_BUTTON_TEXT}
          </div>
        )}
      </button>

      {/* Ordering terms and disclaimer */}
      <div className="text-xs text-gray-500 italic text-center">
        Genom att klicka "{SUBMIT_BUTTON_TEXT}" godkänner du vår{' '}
        <a href={`${config.links.landing}/integritetspolicy`} className="underline text-gray-600">
          integritetspolicy
        </a>{' '}
        och våra{' '}
        <a href={`${config.links.landing}/kopvillkor`} className="underline text-gray-600">
          köpvillkor
        </a>
        .
      </div>
    </div>
  );
}
